import React, {
  FC,
  useEffect,
  useRef,
  useState,
  createRef,
  useMemo,
  useCallback,
} from "react";
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Input, Button, message, TimePicker, Dropdown } from "antd";
import { useMediaQuery } from "react-responsive";
import { ReactSVG } from "react-svg";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import MessageItem from "./MessageItem";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import _ from "lodash";
import { PopupModal } from "components/Modals";
import { useDispatch, useSelector } from "react-redux";
import { PageSettingsModal } from "components/Modals";
import GroupIcon from "assets/SVGs/GroupIcon";
import SettingsIcon from "assets/SVGs/SettingsIcon";
import FilterIcon from "assets/SVGs/FilterIcon";
import CompassIcon from "assets/SVGs/CompassIcon";
import DesktopIcon from "assets/SVGs/DesktopIcon";
import DocIcon from "assets/SVGs/DocIcon";
import { PAGE_TYPES } from "utils/PageTypes";
import { SummaryModal } from "components/Modals";
import { AnalyticsSummaryModalTemp } from "components/Modals";
import "./MapPanel.scss";
import moment from "moment";
import { PeopleModal } from "components/Modals";
import { AddSurveyModal } from "components/Modals";
import {
  getTwilioSaveRecordingSubscriptionTopic,
  getTwilioSaveVideoRecordingPublishTopic,
  getTwilioVideoEndSubscriptionTopic,
  getPageTypingSubscriptionTopic,
  getTwilioVideoJoinSubscriptionTopic,
  getTwilioVideoLeftSubscriptionTopic,
  disconnectPageRequestPublishTopic,
  connectPageRequestPublishTopic,
  getSearchMessageSubscriptionTopic,
  getSearchMessagePublishTopic,
  getCreateMessagePublishTopic,
  getModifyPageSubscriptionTopic,
  getMembersRemoveFromPagePublishTopic,
} from "hooks/MQTTConstants";
import AddEventModal from "components/Modals/AddEventModal";
import AddPayModal from "components/Modals/AddPayModal";
import IoTAlertModal from "components/Modals/IoTAlertModal";
import { UPLOAD_MEDIA } from "../../../reducers/authReducer";

import { CID, RID } from "../../../constants/localStoreKeys";
import {
  getRequestHeader,
  wrapRequestPayload,
  getMessageRequestPayload,
} from "../../../helpers/request/RequestPayload";
import useLocalStorageService from "../../../services/localStorage";

import ConfirmationModal from "components/Modals/ConfirmationModal";
import { RootState } from "reducers/rootReducer";
import { SocketTopics, MessageEventType } from "../../../constants/enums";
import { generateUUID } from "utils/appUtil";
import { current } from "@reduxjs/toolkit";
import { FileDrop } from "react-file-drop";
import { ENCRYPT_TOKEN } from "reducers/authReducer";
import { select } from "redux-saga/effects";

const dragDrop = require("drag-drop");

const { TextArea } = Input;

const MessageSpliterToday = () => (
  <div className="message-spliter-today">
    <label>TODAY</label>
  </div>
);

const MessageSpliterNews = () => (
  <div className="message-spliter-news">
    <label>New messages</label>
  </div>
);

const MessageUserAdded = () => (
  <div className="message-user-added">
    <h4>11:12:48</h4>
    <p>
      <span>Leonetta Lloyd</span> has been added to the page by zsolt.lengyel{" "}
    </p>
  </div>
);

const MessageOppositeUserStatus: FC<{ user: string }> = ({ user }) => (
  <div className="message-opposite-user-status">
    <label>{user} is typing </label>
    <Loader type="ThreeDots" color="#91A5C6" height={10} width={10} />
  </div>
);

const clientId: string = "60c83dcefe8cea1cd6699618";
let timeout: NodeJS.Timeout;
let scrollTimeout: NodeJS.Timeout;
let typingTimeout: NodeJS.Timeout;
let typingByTimeout: NodeJS.Timeout;

const MessagePanel: FC<{ socket: ISocket; params: DashboardParams }> = ({
  socket,
  params,
}) => {
  const { screens, setScreens } = params;
  const isMobileScreen = useMediaQuery({ query: "(max-width: 700px)" });
  const { messages, messageToSend, searchMessages, messageFilter } =
    useSelector((state: RootState) => state.message);
  const { users, allUsers } = useSelector((state: RootState) => state.auth);
  const { saveRecordingNotification } = useSelector(
    (state: RootState) => state.search
  );
  const { requestIds } = useSelector((state: RootState) => state.dashboard);
  const { fileToSend } = useSelector((state: RootState) => state.message);
  const messagesEndRef = useRef<null | HTMLDivElement>(null);
  const [messagesVisible, setMessageVisible] = useState<boolean>(false);

  const dispatch = useDispatch();

  const [popupDisplayed, setPopUpDisplayed] = useState(false);
  const [peoplePopupDisplayed, setPeoplePopupDisplayed] = useState(false);
  const [filterPopupDisplayed, setFilterPopUpDisplayed] = useState(false);
  const [settingsModalDisplayed, setSettingsModalDisplayed] = useState(false);
  // const [summaryModalDisplayed, setSummaryModalDisplayed] = useState(false);
  // const [surveyModalDisplayed, setSurveyModalDisplayed] = useState(false);
  const [selectedMessageType, setSelectedMessageType] = useState("push");
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [text, setText] = useState("");
  const [editTitle, setEditTitle] = useState(false);
  const [currentLocation, setCurrentLocation] = useState<CurrentLocation>();
  const [pageGroups, setPageGroups] = useState([]);

  const [eventModalOpen, setEventModalOpen] = useState<any>({ visible: false });
  const [payModalOpen, setPayModalOpen] = useState<any>({ visible: false });
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState<any>({});

  const [accepting, setAccepting] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [files, setFiles] = useState<any>();

  const scrollToId = useRef(undefined);

  const { readBy, pageTyping } = useSelector(
    (state: RootState) => state.search
  );

  const { pageConnection } = useSelector(
    (state: RootState) => state.search
    // (a, b) => {
    //   return JSON.stringify(a.pageConnection) === JSON.stringify(b.pageConnection);
    // }
  );

  const { selectedItem } = useSelector((state: RootState) => state.search);
  // const { focusMessage } = useSelector((state: RootState) => state.message);

  const pageId = useSelector(
    (state: RootState) => state.search.selectedItem,
    (a, b) => {
      return a?.pageId === b?.pageId;
    }
  )?.pageId;

  const memberActive = useSelector(
    (state: RootState) => state.search.selectedItem,
    (a, b) => {
      return a?.memberActive === b?.memberActive;
    }
  )?.memberActive;

  const [title, setTitle] = useState(
    selectedItem?.persistent?.static?.metadata?.title
  );
  const { getLocalStorageItem } = useLocalStorageService();
  const [edit, setEdit] = useState<MessageObj>();
  const [typing, setTyping] = useState<string>("");
  const type =
    selectedItem &&
    selectedItem?.type &&
    selectedItem?.type === PAGE_TYPES.BROADCAST
      ? "orange"
      : undefined;
  const color = type && type === "orange" ? "#FF5F25" : "#508AFA";
  const openPopupModal = () => {
    setPopUpDisplayed(true);
  };

  const openInNewWindow = () => {
    window.open(
      window.location.origin + `/map/${selectedItem?.pageId}`,
      "_blank",
      "toolbar=0,location=0,menubar=0"
    );
  };

  const menu = (
    <ul className="user-dropdown">
      <li>
        <Link
          to={`/map/${selectedItem?.pageId}`}
          target="_blank"
          className="ml-3 text-white"
        >
          Open New Tab
        </Link>
      </li>
      <li onClick={openInNewWindow}>
        <span className="ml-3">Open New Window</span>
      </li>
    </ul>
  );

  useEffect(() => {
    if (files?.[0]) {
      let form = new FormData();
      form.append("file", files?.[0]);
      form.append(
        "info",
        JSON.stringify({
          pageId: selectedItem.pageId,
          userId: localStorage.getItem("RID"),
          location: {
            coordinates: {
              lat: currentLocation.latitude,
              long: currentLocation.longitude,
            },
            clbs: {
              tags: [
                "type:media",
                `org:${selectedItem?.persistent?.static?.iotAsset?.config?.configUserCudbServiceId}`,
                `name:${files?.[0]}`,
              ],
            },
          },
        })
      );
      dispatch(UPLOAD_MEDIA({ form, isBio: false }));
      setFiles(undefined);
    }
  }, [files]);

  useEffect(() => {
    getCurrentLocation();
    dragDrop("#dropTarget", {
      onDrop: (files, pos, fileList, directories) => {
        setFiles(files);
      },
    });
  }, []);

  useEffect(() => {
    if (socket.client && selectedItem?.memberActive) {
      const groups =
        selectedItem?.persistent?.static?.metadata?.members?.groups ?? {};
      setPageGroups(Object.keys(groups));
    }
    if (selectedItem?.nonpersistent?.static?.live?.connections) {
      let connectionsTypings = [];
      Object.keys(selectedItem?.nonpersistent?.static?.live?.connections).map(
        (connection) => {
          if (
            connection !== localStorage.getItem("CID") &&
            selectedItem?.nonpersistent?.static?.live?.connections[connection]
              .isTyping
          ) {
            connectionsTypings.push(connection);
          }
        }
      );
      let typingUsers = [];
      connectionsTypings.map((connection) => {
        let userId =
          selectedItem?.nonpersistent?.static?.metadata?.connections?.[
            connection
          ]?.userId;
        let findUser = allUsers?.find((obj) => obj.id === userId);
        let userName = findUser?.beamId || `user# ${userId}`;
        typingUsers.push(userName);
      });
      if (typingUsers.length > 0) {
        setTyping(`${typingUsers.join(", ")}`);
      } else {
        setTyping("");
      }
    }
    setTitle(selectedItem?.persistent?.static?.metadata?.title);
  }, [selectedItem]);

  const subscribeToConnection = () => {
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioVideoJoinSubscriptionTopic()
    );
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioVideoLeftSubscriptionTopic()
    );
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioSaveRecordingSubscriptionTopic()
    );
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioVideoEndSubscriptionTopic()
    );

    // TODO: move the path with proper Name to MQTTConstant file
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/service/live/page/${
        selectedItem?.pageId
      }/bds/nonpersistent/static/metadata/connections/${localStorage.getItem(
        "CID"
      )}/groups/+`,
      (data) => {
        if (!data.status) {
          dispatch({
            type: "CLEAR_MESSAGE",
            payload: { pageId: selectedItem?.pageId },
          });
        }
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getPageTypingSubscriptionTopic(selectedItem?.pageId)
    );

    // TODO: move the path with proper Name to MQTTConstant file
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getSearchMessageSubscriptionTopic(selectedItem?.pageId)
    );

    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      disconnectPageRequestPublishTopic(),
      wrapRequestPayload({
        ...getRequestHeader(getLocalStorageItem(CID), getLocalStorageItem(RID)),
        pageId: selectedItem?.pageId,
      }),
      (data: any) => {
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          connectPageRequestPublishTopic(),
          wrapRequestPayload({
            ...getRequestHeader(
              getLocalStorageItem(CID),
              getLocalStorageItem(RID)
            ),
            pageId: selectedItem?.pageId,
          }),
          (data) => {
            if (!data.status) {
              console.log("Publish error: ", data.message);
            }
          }
        );
      }
    );

    getCurrentLocation();
  };

  useEffect(() => {
    if (pageId) {
      subscribeToConnection();
      // scrollToBottom();
      setMessageVisible(false);
    }
  }, [pageId]);

  useEffect(() => {
    if (memberActive) {
      subscribeToConnection();
    }
  }, [memberActive]);

  useEffect(() => {
    if (messages?.[pageId] && scrollToId.current) {
      const scrollTo = document.getElementById(scrollToId.current);
      if (scrollTo) {
        scrollTo.scrollIntoView(true);
      } else {
        if (scrollTimeout) clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          scrollToBottom();
        }, 500);
      }
      scrollToId.current = undefined;
    } else {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        scrollToBottom();
      }, 500);
    }
  }, [messages?.[pageId]?.length, pageId]);

  function formatForRedis(text) {
    return text.replace(/-|_|\./g, function (x) {
      return `\\${x}`;
    });
  }

  const getMessage = (offset = 0, limit = 20) => {
    const requestId = generateUUID();
    localStorage.setItem("requestId", requestIds.message);
    console.log("request message");

    const messageRequest: any = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:message:createdAt`,
          searchQuery: `@pageId:{${selectedItem?.pageId}}`,
          searchOptions: "TIMEOUT 2000",
        },
        load: { object: "$" },
      },
      operations: [
        {
          sortBy: {
            properties: [
              {
                field: "@createdAt",
                order: "DESC",
              },
            ],
          },
        },
      ],
      result: {
        pagination: {
          offset,
          limit,
        },
      },
      sortBy: {
        properties: [
          {
            field: "@createdAt",
            order: "DESC",
          },
        ],
        max: 10000,
      },
    };

    console.log("message request", messageRequest);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/bds/aggregateBds`,
      wrapRequestPayload(messageRequest, requestIds.message)
    );

    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   getSearchMessagePublishTopic(selectedItem?.pageId),
    //   wrapRequestPayload(
    //     {
    //       paths: ["$"],
    //       returnPaths: ["$"],
    //       select: {
    //         index: {
    //           searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:messageCreatedAtIndex`,
    //           searchQuery: `@pageId:{${selectedItem?.pageId}}${
    //             messageFilter && messageFilter.length > 0
    //               ? `@type:{${messageFilter.map(formatForRedis).join("|")}}`
    //               : ""
    //           }`,
    //           searchOptions: "SORTBY createdAt DESC ",
    //         },
    //       },
    //       pagination: {
    //         offset,
    //         limit,
    //       },
    //     },
    //     requestId
    //   )
    // );
  };

  useEffect(() => {
    if (searchMessages) {
      const { limit, offset, scroll } = searchMessages;
      if (scroll) getMessage(offset, limit);
    }
  }, [searchMessages]);

  useEffect(() => {
    if (pageConnection) {
      // TODO: move the path with proper Name to MQTTConstant file
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/service/live/page/${selectedItem?.pageId}/group/members`
      );

      // let groupQuery = "@.group == 'members'";
      for (let group of pageConnection.groups) {
        // TODO: move the path with proper Name to MQTTConstant file
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          `${process.env.REACT_APP_ECO_SYSTEM}/service/live/page/${selectedItem?.pageId}/group/${group}`
        );
        // groupQuery+= ` || @.group == '${group}'`;
      }

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/page/${selectedItem?.pageId}/focusMessage`
      );

      // getMessage();
      dispatch({
        type: "SEARCH_MESSAGES",
        payload: { offset: 0, limit: 30, scroll: true, paginate: false },
      });
    }
  }, [pageConnection]);

  useEffect(() => {
    if (messageToSend) {
      sendMessage(
        messageToSend.message,
        messageToSend.type,
        messageToSend.data,
        undefined,
        messageToSend.edit
      );
      setPopUpDisplayed(false);
    }
  }, [messageToSend]);

  useEffect(() => {
    if (messageFilter) {
      console.log("filter message", messageFilter);
      // getMessage(0, 30, messageFilter);
    }
  }, [messageFilter]);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCurrentLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  const updateTitle = () => {
    if (title && title !== "") {
      const payload: IMessage = getMessageRequestPayload(
        getLocalStorageItem(CID),
        getLocalStorageItem(RID),
        selectedItem?.pageId,
        getCreateMessagePublishTopic(selectedItem?.pageId),
        MessageEventType.UpdatePageTitle,
        {
          title,
        }
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getModifyPageSubscriptionTopic(selectedItem?.pageId),
        wrapRequestPayload(payload)
      );
    }
    setEditTitle(false);
  };

  const sendPageUpdateEvent = (type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem?.pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem?.pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const acceptInvitation = () => {
    sendPageUpdateEvent("acceptPageInvite", {
      userId: localStorage.getItem("RID"),
    });
    setAccepting(true);
  };

  const rejectInvitation = () => {
    sendPageUpdateEvent("rejectPageInvite", {
      userId: localStorage.getItem("RID"),
    });

    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getMembersRemoveFromPagePublishTopic(localStorage.getItem("RID")),
      {
        pattern: getMembersRemoveFromPagePublishTopic(
          localStorage.getItem("RID")
        ),
        data: selectedItem.pageId,
      }
    );

    setRejecting(true);
  };

  useEffect(() => {
    if (fileToSend && !fileToSend.isBio) {
      setPopUpDisplayed(false);
      sendMessage(fileToSend.originalName, "media", {
        ...fileToSend,
        location: {
          coordinates: {
            lat: currentLocation?.latitude || 0,
            long: currentLocation?.longitude || 0,
          },
        },
        clientId,
      });
    }
    dispatch({
      type: "ADD_FILE",
      payload: undefined,
    });
  }, [fileToSend]);

  const sendMessage = (
    message: string | undefined,
    type: string | undefined,
    data: any = undefined,
    del: any = undefined,
    ediT: any = undefined
  ) => {
    if (socket.client) {
      setMessageVisible(false);
      const editTemp = ediT ? ediT : edit;
      const messageRef: IReferenceType = {
        referenceType: (editTemp ? "update" : del ? "remove" : "refer") as any,
        pageMessageId: editTemp ? editTemp.id : del ? del.id : undefined,
      };
      const payload: IMessage = getMessageRequestPayload(
        getLocalStorageItem(CID),
        getLocalStorageItem(RID),
        selectedItem?.pageId,
        getCreateMessagePublishTopic(selectedItem?.pageId),
        editTemp?.messageType ? editTemp.messageType : type,
        {
          ...(editTemp?.data ? editTemp.data : data),
          body: message,
        },
        editTemp
          ? editTemp.originalCreatedAt
          : del
          ? del.originalCreatedAt
          : undefined,
        messageRef,
        editTemp
          ? editTemp.originalPageMessageId
            ? editTemp.originalPageMessageId
            : editTemp.id
          : del
          ? del.originalPageMessageId
            ? del.originalPageMessageId
            : del.id
          : undefined,
        [selectedMessageType]
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
          CID
        )}/page/${selectedItem?.pageId}/group/${
          // selectedMessageType !== "text" ? selectedMessageType : "members"
          "members"
        }`,
        wrapRequestPayload(payload)
      );
      setText("");
      setEdit(undefined);
      // setTimeout(() => scrollToBottom(), 1500);
    }
  };

  const handleMessageSend = () => {
    if (!text) {
      return;
    }
    sendMessage(text, "text", { notify: selectedMessageType === "notify" });
  };

  const scrollToBottom = () => {
    const current = messagesEndRef.current;
    // if (current) current.scrollIntoView();
    if (current) {
      current.scrollTop = current.scrollHeight + -current.clientHeight;
    }

    // const scrollTo = document.getElementById(
    //   messages?.[pageId]?.[messages?.[pageId].length - 1]?.id
    // );
    // if (scrollTo) {
    //   scrollTo.scrollIntoView(true);
    //   setScrollToId(undefined);
    // }

    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      const lastMessage =
        messages[selectedItem?.pageId || 0]?.[
          messages[selectedItem?.pageId || 0]?.length - 1
        ];

      if (
        parseInt(selectedItem?.lastRead?.pageMessageId ?? -1) <
        // parseInt(selectedItem?.lastSent?.pageMessageId ?? -1)
        parseInt(lastMessage?.id ?? -1)
      ) {
        const payload: IMessage = getMessageRequestPayload(
          getLocalStorageItem(CID),
          getLocalStorageItem(RID),
          selectedItem?.pageId,
          getCreateMessagePublishTopic(selectedItem?.pageId),
          MessageEventType.UpdateLastRead,
          {
            userId: getLocalStorageItem(RID),
            updatedAt: new Date().getTime(),
            pageMessageId: lastMessage?.id,
          }
        );

        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getModifyPageSubscriptionTopic(selectedItem?.pageId),
          wrapRequestPayload(payload)
        );
      }
    }, 1000);
  };

  // useEffect(() => {
  //   if (messagesVisible) {
  //     setTimeout(() => scrollToBottom(), 500);
  //     // setScrollToId(messages?.[pageId]?.[messages?.[pageId].length]?.id);

  //     // setTimeout(() => {
  //     //   console.log('id here', messages?.[pageId]?.[messages?.[pageId].length]?.id);

  //     //   const scrollTo = document.getElementById(
  //     //     messages?.[pageId]?.[messages?.[pageId].length - 1]?.id
  //     //   );
  //     //   if (scrollTo) {
  //     //     scrollTo.scrollIntoView(true);
  //     //     setScrollToId(undefined);
  //     //   }
  //     // }, 500);

  //   }
  // }, [messagesVisible]);

  const handleMapClick = () => {
    dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
    dispatch({
      type: "SET_ENABLED_FILTER",
      payload: [],
    });
    dispatch({
      type: "SET_SELECTED_FILTER",
      payload: undefined,
    });
    setScreens({ ...screens, map: true });
  };

  const deleteMessage = (message: MessageObj) => {
    sendMessage(
      undefined,
      message.messageType,
      // { type: message.data.type },
      message.data,
      {
        id: message.id,
        originalCreatedAt: message.originalCreatedAt,
        originalPageMessageId: message.originalPageMessageId,
      }
    );
  };

  const editMessage = (message: MessageObj) => {
    setEdit(message);
    setText(message.message);
  };

  const handleVideoIconClick = () => {
    // popupCenter(
    //   window.location.origin + `/video/${selectedItem?.pageId}`,
    //   "beamLive Video Call",
    //   800,
    //   600
    // );

    const user = allUsers?.find(
      (obj) => obj.id === localStorage.getItem("RID")
    );
    dispatch(
      ENCRYPT_TOKEN({
        data: {
          payload: JSON.stringify({
            userId: localStorage.getItem("RID"),
            userBeamId: user?.beamId,
            connectionId: `${localStorage.getItem("CID")}`,
            pageId: selectedItem?.pageId,
            pageTitle:
              selectedItem?.persistent?.static?.metadata?.title ||
              (selectedItem?.persistent?.static?.metadata?.type === "friend" &&
              getFriendUser(
                selectedItem?.persistent?.static?.metadata?.members?.users
              )
                ? getFriendUser(
                    selectedItem?.persistent?.static?.metadata?.members?.users
                  )
                : `Page ${selectedItem?.pageId}`),
          }),
        },
        callback: (token) => {
          // console.log("encrrypted token here", token);
          window.open(
            `${process.env.REACT_APP_VIDEO_URI}/room/${token.encryptedPayload}`,
            "_blank"
          );
          // console.log('url here', `${process.env.REACT_APP_ADMIN_API}?token=${token.encryptedPayload}`)
        },
      })
    );
  };

  const updateTyping = (typing) => {
    const payload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem?.pageId,
      getCreateMessagePublishTopic(selectedItem?.pageId),
      "updateIsTyping",
      {
        isTyping: typing,
      }
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem?.pageId),
      wrapRequestPayload(payload)
    );
  };

  const onKeyDown = () => {
    if (typingTimeout) return;
    // socket.publishToEvent(SocketTopics.PublishPageTopics,`${process.env.REACT_APP_ECO_SYSTEM}/page/${
    //   selectedItem?.pageId
    // }/connection/${getLocalStorageItem(CID)}/pageTyping`, {
    //   pageId: selectedItem?.pageId,
    //   userId: getLocalStorageItem(RID),
    // } );
    updateTyping(true);
    typingTimeout = setTimeout(() => {
      typingTimeout = undefined;
      updateTyping(false);
    }, 1000);
  };

  const popupCenter = (url: string, title: string, w: number, h: number) => {
    const dualScreenLeft =
      window.screenLeft != undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop != undefined ? window.screenTop : window.screenY;

    // const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    // const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    // const systemZoom = width / window.screen.availWidth;
    // const left = (width - w) / 2 / systemZoom + dualScreenLeft
    // const top = (height - h) / 2 / systemZoom + dualScreenTop
    const newWindow = window.open(
      url,
      title,
      "scrollbars=no,status=no,location=no,toolbar=no,menubar=no,width=" +
        w +
        ", height=" +
        h
    );

    // Puts focus on the newWindow
    if (newWindow?.focus) {
      newWindow.focus();
    }
  };

  useEffect(() => {
    if (saveRecordingNotification) {
      setConfirmationDialog(true);
    }
  }, [saveRecordingNotification]);

  useEffect(() => {
    setAccepting(false);
    setRejecting(false);
  }, [memberActive]);

  const handleSaveVideo = () => {
    const userId = localStorage.getItem("RID");
    const page: any = saveRecordingNotification?.page;
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getTwilioSaveVideoRecordingPublishTopic(),
      {
        pageId: page?.id,
        userId,
        roomId: page?.videoRoomId,
        save: true,
      }
    );
    setConfirmationDialog(false);
    dispatch({ type: "RESET_STATE" });
  };
  const handleCancelRecording = () => {
    setConfirmationDialog(false);
    dispatch({ type: "RESET_STATE" });
  };

  const MessageItems = useMemo(() => {
    return (
      <React.Fragment>
        {messages?.[pageId]?.map((message: MessageObj, index) => (
          <MessageItem
            key={index}
            screens={screens}
            setScreens={setScreens}
            socket={socket}
            onMessageVisible={() => {
              // setMessageVisible(true)
            }}
            onEdit={editMessage}
            readBy={readBy}
            onRemove={deleteMessage}
            message={message}
            page={selectedItem}
            // key={Math.random()}
            onEvent={(event, mode?: any) => {
              setSelectedMessage(message);
              switch (event) {
                case "event":
                  setEventModalOpen({ visible: true, mode });
                  break;
                case "alert":
                  setAlertModalOpen(true);
                  break;
                case "pay":
                  setPayModalOpen({ visible: true, mode });
                  break;
              }
            }}
          />
        ))}
      </React.Fragment>
    );
  }, [JSON.stringify(messages?.[pageId]), pageId, selectedItem]);

  // useEffect(()=>{
  //   setTimeout(()=>{
  //     scrollToBottom();
  //   }, 500)
  // }, [messages?.[pageId]?.length])

  const getFriendUser = (members) => {
    const userIndex = Object.keys(members).find((x) => {
      return x !== localStorage.getItem("RID");
    });
    const user = allUsers?.find((obj) => obj.id === userIndex);
    return user?.beamId;
  };

  return (
    <div className="main-column message-panel mr-4">
      <div className="main-content">
        <div className="main-header">
          <div className="d-flex">
            <GroupIcon color={color} />

            {!editTitle ? (
              <React.Fragment>
                <h3 className="ml-3" style={{ color }}>
                  {selectedItem?.persistent?.static?.metadata?.title ||
                    (selectedItem?.persistent?.static?.metadata?.type ===
                      "friend" &&
                    getFriendUser(
                      selectedItem?.persistent?.static?.metadata?.members?.users
                    )
                      ? getFriendUser(
                          selectedItem?.persistent?.static?.metadata?.members
                            ?.users
                        )
                      : `Page ${selectedItem?.pageId}`)}
                </h3>
                {selectedItem?.persistent?.static?.metadata?.type !==
                  "friend" && (
                  <ReactSVG
                    className="ml-3 sz-18"
                    src="/images/edit-icon.svg"
                    onClick={() => {
                      setEditTitle(true);
                    }}
                  />
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Input
                  className="ml-3"
                  value={title}
                  onChange={(e: any) => setTitle(e.target.value)}
                  onKeyUp={(e: any) => {
                    if (e.key === "Enter" || e.keyCode === 13) {
                      updateTitle();
                    }
                  }}
                />
                <ReactSVG
                  className="ml-3 close-icon"
                  src="/images/close-icon.svg"
                  onClick={() => {
                    setEditTitle(false);
                  }}
                />
              </React.Fragment>
            )}
          </div>
          <div className="d-flex">
            <ReactSVG
              src="/images/expand-icon.svg"
              className="close-icon mr-4"
              onClick={() =>
                setScreens({
                  ...screens,
                  active: screens.active ? "" : "message",
                })
              }
            />
            {!isMobileScreen && (
              <ReactSVG
                src="/images/close-icon.svg"
                className="close-icon"
                onClick={() => setScreens({ ...screens, message: false })}
              />
            )}
          </div>
        </div>
        <div className="search-bar mt-3">
          <div className="d-flex">
            <Input
              className="beam-input"
              placeholder="Search..."
              suffix={<SearchOutlined />}
            />
            {/* <Button
              className="beam-btn ml-2"
              onClick={() => setSurveyModalDisplayed(true)}
            >
              <DocIcon />
            </Button>
            <Button
              className="beam-btn ml-2"
              onClick={() => setSummaryModalDisplayed(true)}
            >
              <DesktopIcon />
            </Button> */}
            <Button
              className="beam-btn ml-2"
              onClick={() => {
                // setSettingsModalDisplayed(true)
              }}
            >
              <SettingsIcon />
            </Button>
            <Button
              className="beam-btn ml-2"
              onClick={() => setFilterPopUpDisplayed(true)}
            >
              <FilterIcon />
            </Button>
            {/* <Dropdown
              overlay={menu}
              placement="bottomRight"
              trigger={["contextMenu"]}
            > */}
            <Button className="beam-btn ml-2" onClick={handleMapClick}>
              <CompassIcon />
            </Button>
            {/* </Dropdown> */}
          </div>
        </div>

        {/* <FileDrop
          onFrameDragEnter={(event) => console.log('onFrameDragEnter', event)}
          onFrameDragLeave={(event) => console.log('onFrameDragLeave', event)}
          onFrameDrop={(event) => console.log('onFrameDrop', event)}
          onDragLeave={(event) => console.log('onDragLeave', event)}
          onDrop={(files, event) => console.log('onDrop!', files, event)}
        > */}

        {/* <div className="dropper">
            <p>Drop media to upload</p>
</div> */}

        <div
          ref={messagesEndRef}
          className="main-cards"
          id="dropTarget"
          onScroll={(e: any) => {
            const top = e.target.scrollTop === 0;
            if (top && searchMessages.scroll && messages?.[pageId]?.[0]?.id) {
              // setScrollToId(messages?.[pageId]?.[0]?.id);
              scrollToId.current = messages?.[pageId]?.[0]?.id;
              dispatch({
                type: "SEARCH_MESSAGES",
                payload: {
                  offset: searchMessages.offset + searchMessages.limit,
                  paginate: true,
                },
              });
            }
          }}
        >
          <div className="dropper">
            <p>Drop media to upload</p>
          </div>

          {
            messages[pageId || 0] && memberActive && (
              <React.Fragment>{MessageItems}</React.Fragment>
            )
            // messages?.[pageId]?.map((message: MessageObj, index) => (
            //   <MessageItem
            //     key={}
            //     screens={screens}
            //     setScreens={setScreens}
            //     socket={socket}
            //     onMessageVisible={() => setMessageVisible(true)}
            //     onEdit={editMessage}
            //     readBy={readBy}
            //     onRemove={deleteMessage}
            //     message={message}
            //     page={selectedItem}
            //     // key={Math.random()}
            //     onEvent={(event) => {
            //       setSelectedMessage(message);
            //       switch (event) {
            //         case "event":
            //           setEventModalOpen(true);
            //           break;
            //         case "alert":
            //           setAlertModalOpen(true);
            //           break;
            //       }
            //     }}
            //   />
            // ))}
          }
          {pageId && !memberActive && (
            <div className="d-block align-items-center invite-container">
              {/* <h4>You have been invited to this page</h4> */}
              <h3 className="font-weight-bold">
                {selectedItem?.persistent.static.metadata?.members?.users?.[
                  localStorage.getItem("RID")
                ]?.pending?.invitedBy ?? "Beamer"}
              </h3>
              <h4>has invited you to this page</h4>
              <Row className="action-grp mt-4 w-full">
                <Col span={12} className="pr-2">
                  <Button
                    className="beam-btn green-btn cover w-full"
                    loading={accepting}
                    onClick={() => {
                      acceptInvitation();
                    }}
                  >
                    Accept
                  </Button>
                </Col>
                <Col span={12} className="pr-2">
                  <Button
                    loading={rejecting}
                    className="beam-btn orange-btn bordered w-full"
                    onClick={() => {
                      rejectInvitation();
                    }}
                  >
                    Decline
                  </Button>
                </Col>
                {/* <Col span={8} className="pr-2">
                        <button
                          type="button"
                          className="beam-btn orange-btn bordered w-full"
                        >
                          Block
                        </button>
                      </Col> */}
              </Row>
            </div>
          )}

          {/* <div ref={messagesEndRef} /> */}
        </div>

        {/* </FileDrop> */}

        {selectedItem &&
          (selectedItem?.currentUserRole === "edit" ||
            selectedItem?.currentUserRole === "write") &&
          selectedItem?.memberActive && (
            <div className="main-footer">
              {typing && typing !== "" && (
                <MessageOppositeUserStatus user={typing} />
              )}
              <div className="message-input">
                <div className="message-btn">
                  <Button className="beam-btn" onClick={openPopupModal}>
                    <ReactSVG
                      src="/images/plus-icon.svg"
                      className="add-icon"
                    />
                  </Button>
                  <p>More</p>
                </div>

                {/* <div className="ml-3 message-btn">
                  <Button
                    className="beam-btn"
                    onClick={() => setSummaryModalDisplayed(true)}
                  >
                    <DesktopIcon />
                  </Button>
                  <p>Summary</p>
                </div>

                <div className="ml-3 message-btn">
                  <Button
                    className="beam-btn"
                    onClick={() => setSurveyModalDisplayed(true)}
                  >
                    <DocIcon />
                  </Button>
                  <p>Survey</p>
                </div> */}

                <TextArea
                  onKeyDown={onKeyDown}
                  value={text}
                  autoSize={{ minRows: 1, maxRows: 6 }}
                  onChange={(e) => {
                    setText(e.target.value);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      if (e.shiftKey) {
                      } else {
                        e.preventDefault();
                        handleMessageSend();
                      }
                    }
                  }}
                  placeholder="Type a message..."
                />
                <Button className="beam-btn ml-2" onClick={handleMessageSend}>
                  {text ? (
                    <ReactSVG src="/images/send.svg" />
                  ) : (
                    <ReactSVG
                      onClick={handleVideoIconClick}
                      src="/images/media-icon.svg"
                    />
                  )}
                </Button>
              </div>
              {text && (
                <div>
                  {selectedMessageType === "snap" && (
                    <Col span={24} className="datetime-item mt-1 mb-1">
                      <img src="/images/time.png" />
                      <TimePicker
                        placeholder="Enter time in secs"
                        suffixIcon={<DownOutlined />}
                      />
                    </Col>
                  )}
                  <Row className="d-flex">
                    <Col span={5}>Message Type</Col>
                    <Col className="text-right" span={4}>
                      <Button
                        onClick={() => setSelectedMessageType("push")}
                        className={`type-button${
                          selectedMessageType === "push" ? " type-selected" : ""
                        }`}
                      >
                        Text
                      </Button>
                    </Col>
                    <Col className="text-right" span={5}>
                      <Button
                        onClick={() => setSelectedMessageType("notify")}
                        className={`type-button${
                          selectedMessageType === "notify"
                            ? " type-selected"
                            : ""
                        }`}
                      >
                        Notify
                      </Button>
                    </Col>
                    {/* <Col className="text-right" span={5}>
                      <Button
                        onClick={() => setSelectedMessageType("snap")}
                        className={`type-button${
                          selectedMessageType === "snap" ? " type-selected" : ""
                        }`}
                      >
                        Snap
                      </Button>
                    </Col> */}

                    <Col className="text-right" span={5}>
                      <Button
                        onClick={() => setSelectedMessageType("email")}
                        className={`type-button${
                          selectedMessageType === "email"
                            ? " type-selected"
                            : ""
                        }`}
                      >
                        Email
                      </Button>
                    </Col>

                    <Col className="text-right" span={4}>
                      <Button
                        onClick={() => setSelectedMessageType("sms")}
                        className={`type-button${
                          selectedMessageType === "sms" ? " type-selected" : ""
                        }`}
                      >
                        Sms
                      </Button>
                    </Col>

                    {pageGroups.map((groupName, idx) => (
                      <React.Fragment>
                        <Col key={idx} className="text-right" span={4}>
                          <Button
                            className={`type-button${
                              selectedMessageType === groupName
                                ? " type-selected"
                                : ""
                            }`}
                            onClick={() => setSelectedMessageType(groupName)}
                          >
                            {groupName}
                          </Button>
                        </Col>
                      </React.Fragment>
                    ))}
                  </Row>
                </div>
              )}
            </div>
          )}
      </div>
      {popupDisplayed && (
        <PopupModal
          socket={socket}
          type="MESSAGE"
          onClose={() => setPopUpDisplayed(false)}
        />
      )}
      {filterPopupDisplayed && (
        <PopupModal
          // onSelectedFilterUpdate={console.log}
          type="FILTER"
          onClose={() => setFilterPopUpDisplayed(false)}
        />
      )}
      {settingsModalDisplayed && (
        <PageSettingsModal onClose={() => setSettingsModalDisplayed(false)} />
      )}
      {/* {surveyModalDisplayed && (
        <AddSurveyModal onClose={() => setSurveyModalDisplayed(false)} />
      )}
      {summaryModalDisplayed && (
        <AnalyticsSummaryModalTemp
          onClose={() => setSummaryModalDisplayed(false)}
        />
      )} */}
      {peoplePopupDisplayed && (
        <PeopleModal
          socket={socket}
          onClose={() => setPeoplePopupDisplayed(false)}
        />
      )}
      {confirmationDialog && (
        <ConfirmationModal
          handleConfirm={handleSaveVideo}
          message={"Archive video?"}
          onClose={handleCancelRecording}
          okMessage={"Yes"}
          cancelMessage={"No"}
        />
      )}
      {eventModalOpen?.visible && (
        <AddEventModal
          onClose={() => setEventModalOpen({ visible: false })}
          eventObj={selectedMessage?.data}
          mode={eventModalOpen?.mode}
          id={`${selectedMessage?.id}${localStorage.getItem("RID")}`}
          socket={socket}
          message={selectedMessage}
        />
      )}

      {payModalOpen?.visible && (
        <AddPayModal
          onClose={() => setPayModalOpen({ visible: false })}
          eventObj={selectedMessage?.data}
          mode={payModalOpen?.mode}
          id={`${selectedMessage?.id}${localStorage.getItem("RID")}`}
          socket={socket}
          message={selectedMessage}
        />
      )}

      {alertModalOpen && (
        <IoTAlertModal
          onClose={() => setAlertModalOpen(false)}
          alertObj={selectedMessage?.data}
        />
      )}
    </div>
  );
};

export default MessagePanel;
